import React, { Component, useState } from "react";
import Home from '../pages/Home';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";

import { useNavigate } from 'react-router-dom'; // React Router's useNavigate hook

import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./Login";



const SigninWidget = () => {

  return (
    <div>
      <AuthenticatedTemplate>
        <Home />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  )
}

export default SigninWidget
